/* Random tagline under the site title/logo (geek.dev customization).
   Kept in its own file, separate from main.js, so upstream Source
   updates to main.js merge cleanly without touching this. */
(function () {
    const taglines = [
        'Come for the answer, stay for the tangent',
        'Deep dives, no shallow end',
        'Uncompressed curiosity',
        'For the chronically curious',
        'Professionally excavated rabbit holes',
        'The comments section is peer review',
        'sudo make me smarter',
        'Recursion: see recursion',
        'xkcd #356',
        '0% cosplay, 100% source code',
        'Fluent in protocols, not Klingon',
        'ghojlu\'meH QaQ jajvam',
        'LLM Agents welcome, humans optional'
    ];

    const el = document.querySelector('[data-tagline]');
    if (!el) return;

    el.textContent = taglines[Math.floor(Math.random() * taglines.length)];
})();
